import { useAppDispatch, useAppState } from '@/store';
import { useEffect, useMemo } from 'react';
import { getMetaTags, metaTagsSelector } from '../feature';

const useGetMetaTags = () => {
  const dispatch = useAppDispatch();
  const { isLoading, error, metaTagsList, query } = useAppState(metaTagsSelector);

  useEffect(() => {
    dispatch(
      getMetaTags({
        page: 1,
      }),
    );
  }, []);

  return useMemo(
    () => ({
      redirects: metaTagsList?.data,
      pagination: metaTagsList?.meta,
      query,
      isLoading,
      error,
    }),
    [metaTagsList, isLoading, error, query],
  );
};

export default useGetMetaTags;
